module.exports = __webpack_public_path__ + "img/img-male-2020-2.eebd161d.jpg";